import { ReactNode } from "react";

interface LegalSectionProps {
  title: string;
  children: ReactNode;
  level?: 'h2' | 'h3';
}

export const LegalSection = ({ title, children, level = 'h3' }: LegalSectionProps) => {
  const HeadingTag = level;
  
  return (
    <section className="mb-6">
      <HeadingTag className="font-clash text-xl font-semibold tracking-tight mb-3 text-foreground">
        {title}
      </HeadingTag>
      <div className="text-base text-foreground/80 leading-relaxed tracking-wide font-medium space-y-3">
        {children}
      </div>
    </section>
  );
};
